import styled from 'styled-components'
import Chip from '../StyledChip'
import { colors } from '../../styles'
import { Caption } from '../StyledText'
import Link from '../StyledLink'
import placeholder from '../../assets/tr-placeholder.jpg'

export const StyledSearchItemWrapper = styled(Link)`
  all: unset;
  position: relative;
  width: 200px;
  max-width: 200px;
  cursor: pointer;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  &:hover {
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.2),
      0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.12);
  }
`

export const StyledSearchItemPreview = styled.div<{ thumbnail?: string }>`
  position: relative;
  background-image: url(${({ thumbnail }) => `"${thumbnail}"`}),
    url(${placeholder});
  background-size: cover;
  background-position: top left;
  height: 200px;

  .type-tag {
    position: absolute;
    bottom: 4px;
    right: 2px;
    cursor: inherit;

    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  }
`

export const StyledSearchItemFooter = styled.div`
  box-sizing: border-box;
  background: ${colors.silver};
  padding: 8px 12px 12px 12px;
  width: 100%;
  * {
    line-height: 1.15em;
  }
  > h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* Note: min-height depends on the line-height value */
    min-height: calc(2 * 1.15em);
    overflow-wrap: break-word;
  }
  .show-eclipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .delimiter {
    overflow: hidden;
    text-overflow: auto;
    padding: 0 4px;
  }
  .publishing-indicator {
    position: absolute;
    right: 4px;
    bottom: 4px;
  }
`

export const StyledSearchItemCaption = styled(Caption)`
  color: ${colors.grey40};
  font-weight: 400;
`

export const StyledMediaTypeLabel = styled(Chip)`
  span {
    font-weight: bold;
    padding: 2px 6px 3px;
  }
`
